import { render, staticRenderFns } from "./BsModal.vue?vue&type=template&id=0bf91d48&scoped=true&lang=html&"
import script from "./BsModal.vue?vue&type=script&lang=js&"
export * from "./BsModal.vue?vue&type=script&lang=js&"
import style0 from "./BsModal.vue?vue&type=style&index=0&id=0bf91d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf91d48",
  null
  
)

export default component.exports